// import React, { useEffect, useState } from "react";
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   GeoJSON,
//   useMap,
// } from "react-leaflet";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";

// const markerIcon = new L.Icon({
//   iconUrl: require("./marker4.jpg"),
//   iconSize: [24, 35],
//   iconAnchor: [22, 94],
//   popupAnchor: [-3, -76],
// });
// const markerIcon2 = new L.Icon({
//   iconUrl: "https://images.ctfassets.net/3prze68gbwl1/assetglossary-17su9wok1ui0z7w/c4c4bdcdf0d0f86447d3efc450d1d081/map-marker.png",
//   iconSize: [30, 30],
//   iconAnchor: [22, 94],
//   popupAnchor: [-3, -76],
// })

// const FitBoundsHelper = ({ bounds }) => { 
//   const map = useMap();
//   useEffect(() => {
//     if (bounds && bounds.isValid()) {
//       map.fitBounds(bounds, { padding: [20, 20] });
//     }
//   }, [bounds, map]);
//   return null;
// };

// const DigitalAgricultureMap = ({ listData = {}, benchmarkDetails = [] }) => {
//   const [geoJsonData, setGeoJsonData] = useState(null);
//   const [markerCoords, setMarkerCoords] = useState(null);
//   const [benchMarkCoords, setBenchMarkCoords] = useState(null); 
//   const [center, setCenter] = useState([28.5769735, 77.317138]);
//   const [bounds, setBounds] = useState(null);
//   const ZOOM_LEVEL = 5;
 
//   useEffect(() => {
//     if (!listData || Object.keys(listData).length === 0) return;

//     if (
//       listData?.WKT_Geometry?.type === "Polygon" ||
//       listData?.WKT_Geometry?.type === "MultiPolygon"
//     ) {
//       const fixedCoordinates = listData.WKT_Geometry.coordinates.map((ring) =>
//         ring.map(([lat, lng]) => [lng, lat])
//       );
//       const geoJson = {
//         type: "Feature",
//         geometry: {
//           ...listData.WKT_Geometry,
//           coordinates: fixedCoordinates,
//         },
//         properties: {},
//       };
//       setGeoJsonData(geoJson);
//       setCenter([fixedCoordinates[0][0][1], fixedCoordinates[0][0][0]]);
//       const latLngs = fixedCoordinates.flat().map(([lng, lat]) => [lat, lng]);
//       setBounds(L.latLngBounds(latLngs));
//     } 

//   else if (
//   Array.isArray(listData?.LatLong) &&
//   listData?.LatLong[0]?.lat &&
//   listData?.LatLong[0]?.long
// ) {
//   const firstPoint = [listData?.LatLong[0].lat, listData?.LatLong[0].long];
//   setMarkerCoords([firstPoint]);
//   setCenter(firstPoint);
//   setBounds(L.latLngBounds([firstPoint]));
// }

//     else {
//       setGeoJsonData(null);
//       setMarkerCoords(null);
//       setBounds(null);
//     }

//     if (
//       benchmarkDetails?.WKT_Geometry?.type === "Polygon" ||
//       benchmarkDetails?.WKT_Geometry?.type === "MultiPolygon"
//     ) {
//       const fixedCoordinates = benchmarkDetails.WKT_Geometry.coordinates.map((ring) =>
//         ring.map(([lat, lng]) => [lng, lat])
//       );
//       const geoJson = {
//         type: "Feature",
//         geometry: {
//           ...benchmarkDetails.WKT_Geometry,
//           coordinates: fixedCoordinates,
//         },
//         properties: {},
//       };
//       setGeoJsonData(geoJson);
//       setCenter([fixedCoordinates[0][0][1], fixedCoordinates[0][0][0]]);
//       const latLngs = fixedCoordinates.flat().map(([lng, lat]) => [lat, lng]);
//       setBounds(L.latLngBounds(latLngs));
//     } 
//   if (
//   Array.isArray(benchmarkDetails?.LatLong) &&
//   benchmarkDetails?.LatLong[0]?.lat &&
//   benchmarkDetails?.LatLong[0]?.long
// ) {
//   const benchmarkDetailsPoint = [benchmarkDetails?.LatLong[0].lat, benchmarkDetails?.LatLong[0].long];
//   setBenchMarkCoords([benchmarkDetailsPoint]);
// }
//   }, [listData,benchmarkDetails]);
 

 




// return (
//     <div className="row mt-3">
//       <div className="col text-center">
//         <MapContainer
//           center={center}
//           zoom={ZOOM_LEVEL}
//           style={{ height: "50vh", width: "100%" }}
//           scrollWheelZoom={false}
//         >
//           <TileLayer
//             url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
//             attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
//           />

//           {bounds && <FitBoundsHelper bounds={bounds} />}

//           {geoJsonData && (
//             <GeoJSON
//               data={geoJsonData}
//               style={{ color: "#198754", fillOpacity: 0.4 }}
//             />
//           )}

//           {markerCoords &&
//             markerCoords.map((position, index) => (
//               <Marker key={index} position={position} icon={markerIcon} />
//             ))}
//               {benchMarkCoords &&
//             benchMarkCoords.map((position, index) => (
//               <Marker key={index} position={position} icon={markerIcon2} />
//             ))}
            
//         </MapContainer>
//       </div>
//     </div>
//   );
// };
// export default DigitalAgricultureMap;

import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  GeoJSON,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const markerIcon = new L.Icon({
  iconUrl: require("./marker4.jpg"),
  iconSize: [24, 35],
  iconAnchor: [12, 35],
});

const markerIcon2 = new L.Icon({
  iconUrl:
    "https://images.ctfassets.net/3prze68gbwl1/assetglossary-17su9wok1ui0z7w/c4c4bdcdf0d0f86447d3efc450d1d081/map-marker.png",
  iconSize: [30, 30],
  iconAnchor: [15, 30],
});

const FitBoundsHelper = ({ bounds }) => {
  const map = useMap();
  useEffect(() => {
    if (bounds && bounds.isValid()) {
      map.fitBounds(bounds, { padding: [20, 20] });
    }
  }, [bounds, map]);
  return null;
};

const DigitalAgricultureMap = ({listData={},benchmarkDetails={}}) => {
  const [geoJsonData, setGeoJsonData] = useState(null);
  const [markerCoords, setMarkerCoords] = useState(null);
  const [benchMarkCoords, setBenchMarkCoords] = useState(null);
  const [center, setCenter] = useState([28.5769735, 77.317138]);
  const [bounds, setBounds] = useState(null);

  const ZOOM_LEVEL = 15;

  

  useEffect(() => {
    let allLatLngs = [];
      if (!listData || Object.keys(listData).length === 0) return;

    if (
      listData?.WKT_Geometry?.type === "Polygon" ||
      listData?.WKT_Geometry?.type === "MultiPolygon"
    ) {
      const fixedCoordinates = listData?.WKT_Geometry?.coordinates.map((ring) =>
        ring.map(([lat, lng]) => [lng, lat])
      );
      const geoJson = {
        type: "Feature",
        geometry: {
          ...listData.WKT_Geometry,
          coordinates: fixedCoordinates,
        },
        properties: {},
      };
      setGeoJsonData(geoJson);
      // setCenter([fixedCoordinates[0][0][1], fixedCoordinates[0][0][0]]);
      const latLngs = fixedCoordinates.flat().map(([lng, lat]) => [lat, lng]);
       allLatLngs = [...allLatLngs, ...latLngs];

    } 
      else if (
    Array.isArray(listData?.LatLong) &&
    listData?.LatLong[0]?.lat &&
    listData?.LatLong[0]?.long
  ) {
    const firstPoint = [listData.LatLong[0].lat, listData.LatLong[0].long]; 
    setMarkerCoords([firstPoint]);
    allLatLngs.push(firstPoint);
  }
 


 

     if (
      benchmarkDetails?.WKT_Geometry?.type === "Polygon" ||
      benchmarkDetails?.WKT_Geometry?.type === "MultiPolygon"
    ) {
      const fixedCoordinates = benchmarkDetails?.WKT_Geometry?.coordinates.map((ring) =>
        ring.map(([lat, lng]) => [lng, lat])
      );
      const geoJson = {
        type: "Feature",
        geometry: {
          ...benchmarkDetails.WKT_Geometry,
          coordinates: fixedCoordinates,
        },
        properties: {},
      };
      setGeoJsonData(geoJson);
      const latLngs = fixedCoordinates.flat().map(([lng, lat]) => [lat, lng]);
          allLatLngs = [...allLatLngs, ...latLngs];

    } 


  if (
    Array.isArray(benchmarkDetails?.LatLong) &&
    benchmarkDetails?.LatLong[0]?.lat &&
    benchmarkDetails?.LatLong[0]?.long
  ) {
    const benchmarkPoint = [
      benchmarkDetails.LatLong[0].lat,
      benchmarkDetails.LatLong[0].long,
    ]; 
   

    setBenchMarkCoords([benchmarkPoint]);
    allLatLngs.push(benchmarkPoint);
  }



    if (allLatLngs.length > 0) {
      setBounds(L.latLngBounds(allLatLngs));
    }
  }, [listData]);

  return (
    <div className="row mt-3">
      <div className="col text-center">
        <MapContainer
          center={center}
          zoom={ZOOM_LEVEL}
          style={{ height: "50vh", width: "100%" }}
          scrollWheelZoom={false}
        >
          <TileLayer
            url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
            attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
          />

          {bounds && <FitBoundsHelper bounds={bounds} />}

          {geoJsonData && (
            <GeoJSON
              data={geoJsonData}
              style={{ color: "#198754", fillOpacity: 0.4 }}
            />
          )}

          {markerCoords &&
            markerCoords.map((pos, i) => (
              <Marker key={`list-${i}`} position={pos} icon={markerIcon} />
            ))}

          {benchMarkCoords &&
            benchMarkCoords.map((pos, i) => (
              <Marker key={`bm-${i}`} position={pos} icon={markerIcon2} />
            ))}
        </MapContainer>
      </div>
    </div>
  );
};

export default DigitalAgricultureMap;
